(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ej-product-recommendations')) {
    class EJProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this._isConnected) return;

        this._isConnected = true;
        this._isDisconnected = false;
        this.loadRecommendations();
      }

      disconnectedCallback() {
        this._isConnected = false;
        this._isDisconnected = true;

        if (this._controller) {
          this._controller.abort();
        }
      }

      get marker() {
        return this.querySelector('[data-ej-result-marker]');
      }

      get renderedCount() {
        const count = this.marker
          ? Number(this.marker.dataset.count)
          : 0;

        return Number.isFinite(count) ? count : 0;
      }

      setState(state) {
        this.dataset.state = state;
        this.setAttribute('aria-busy', 'false');
      }

      showEmptyState() {
        if (this.renderedCount > 0) {
          this.setState('fallback');
          return;
        }

        const loading = this.querySelector('[data-ej-loading]');
        const empty = this.querySelector('[data-ej-client-empty]');

        if (loading) loading.remove();
        if (empty) empty.hidden = false;

        this.setState('empty');
      }

      async requestMarkup(url) {
        let lastError;

        for (let attempt = 0; attempt < 2; attempt += 1) {
          if (this._isDisconnected) {
            throw new Error('Recommendation section disconnected');
          }

          this._controller = new AbortController();

          const timeout = window.setTimeout(() => {
            this._controller.abort();
          }, 8000);

          try {
            const response = await fetch(url, {
              method: 'GET',
              credentials: 'same-origin',
              cache: 'no-store',
              headers: {
                Accept: 'text/html'
              },
              signal: this._controller.signal
            });

            if (!response.ok) {
              throw new Error(
                `Recommendation request failed with status ${response.status}`
              );
            }

            const text = await response.text();

            if (!text.trim()) {
              throw new Error('Recommendation response was empty');
            }

            return text;
          } catch (error) {
            lastError = error;

            if (this._isDisconnected || attempt === 1) {
              throw error;
            }

            await new Promise((resolve) => {
              window.setTimeout(resolve, 350);
            });
          } finally {
            window.clearTimeout(timeout);
          }
        }

        throw lastError;
      }

      async loadRecommendations() {
        if (
          this._loadingPromise ||
          this.dataset.state === 'loaded'
        ) {
          return;
        }

        const url = this.dataset.url;

        if (!url || !this.dataset.productId) {
          this.showEmptyState();
          return;
        }

        this.setAttribute('aria-busy', 'true');

        this._loadingPromise = (async () => {
          try {
            const text = await this.requestMarkup(url);

            if (this._isDisconnected) return;

            const documentFragment = new DOMParser().parseFromString(
              text,
              'text/html'
            );

            const roots = Array.from(
              documentFragment.querySelectorAll(
                'ej-product-recommendations[data-ej-recommendations-root]'
              )
            );

            const incomingRoot =
              roots.find(
                (root) =>
                  root.dataset.sectionId === this.dataset.sectionId
              ) || roots[0];

            if (!incomingRoot) {
              throw new Error(
                'Recommendation section was missing from response'
              );
            }

            if (
              incomingRoot.dataset.productId !==
              this.dataset.productId
            ) {
              throw new Error(
                'Recommendation response did not match the current product'
              );
            }

            const incomingContent = incomingRoot.querySelector(
              '[data-ej-recommendations-content]'
            );

            const incomingMarker = incomingRoot.querySelector(
              '[data-ej-result-marker]'
            );

            const incomingCount = incomingMarker
              ? Number(incomingMarker.dataset.count)
              : 0;

            const incomingSource = incomingMarker
              ? incomingMarker.dataset.source
              : '';

            if (!incomingContent || !incomingMarker) {
              throw new Error(
                'Recommendation response markup was incomplete'
              );
            }

            if (
              incomingCount > 0 &&
              incomingSource === 'recommendations'
            ) {
              const currentContent = this.querySelector(
                '[data-ej-recommendations-content]'
              );

              if (!currentContent) {
                throw new Error(
                  'Recommendation target was missing'
                );
              }

              currentContent.replaceWith(
                incomingContent.cloneNode(true)
              );

              this.setState('loaded');
            } else if (this.renderedCount > 0) {
              this.setState('fallback');
            } else if (incomingCount > 0) {
              const currentContent = this.querySelector(
                '[data-ej-recommendations-content]'
              );

              currentContent.replaceWith(
                incomingContent.cloneNode(true)
              );

              this.setState('fallback');
            } else {
              const currentContent = this.querySelector(
                '[data-ej-recommendations-content]'
              );

              currentContent.replaceWith(
                incomingContent.cloneNode(true)
              );

              this.setState('empty');
            }

            this.dispatchEvent(
              new CustomEvent('ej:recommendations:loaded', {
                bubbles: true,
                detail: {
                  state: this.dataset.state,
                  count: this.renderedCount
                }
              })
            );
          } catch (error) {
            if (!this._isDisconnected) {
              this.showEmptyState();

              console.warn(
                '[Product recommendations]',
                error
              );
            }
          } finally {
            this._loadingPromise = null;
          }
        })();
      }
    }

    customElements.define(
      'ej-product-recommendations',
      EJProductRecommendations
    );
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      event.target
        .querySelectorAll('ej-product-recommendations')
        .forEach((element) => {
          element.loadRecommendations();
        });
    }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
